module.exports = __webpack_public_path__ + "7c6f1c617042233f230b4021879f0d9f.svg";